import React, { useEffect, useState } from "react";
import { handlePostRequest } from "../../services/PostTemplate";
import { Button } from "primereact/button";

function SubmitFileDetails({ fileHeadId, fileStausDetailsData }) {

    console.log('fileStausDetailsData', fileStausDetailsData)

    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("pi pi-save");
    const [btnDisabled, setBtnDisabled] = useState(true);

    const onSubmit = async () => {
        try {
            setloading(true);
            setloadingIcon("pi pi-spin pi-spinner");
            await handlePostRequest({ fileHeadId }, "zbizgateway/customerFileUpload/submitUploadedFile");
        } catch (err) {
            console.log(err);
        } finally {
            setloading(false);
            setloadingIcon("pi pi-save");
        }
    };

    useEffect(() => {
        const anySuccess = fileStausDetailsData.some((item) => item.statusCode === "S");
        setBtnDisabled(!anySuccess);
    }, [fileStausDetailsData]);

    return (
        <>
            <div className="p-mb-4 Down__Btn">
                <Button onClick={onSubmit} loading={loading} type="submit" icon={loadingIcon || ""} iconPos="right" label={"Submit File Detail"} className="Btn__Dark" disabled={btnDisabled} />
            </div>
        </>
    );
}

export default SubmitFileDetails;
